import styled from "styled-components";

// Constants
import colors from "css/colors";

// Components
import { Button as ButtonBase } from "antd";

export const Wrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 16px;
`;

interface ButtonProps {
  margin?: string;
  danger?: boolean;
}

export const Button = styled(ButtonBase)<ButtonProps>`
  margin: ${(props) => (props.margin ? props.margin : "initial")};
  height: 40px;
  color: ${(props) => (props.danger ? colors.RED : colors.BLUE)};
  border-color: ${(props) => (props.danger ? colors.RED : colors.BLUE)};

  @media screen and (max-width: 375px) {
    &:not(:last-child) {
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }

  @media screen and (max-width: 425px) {
    &:not(:last-child) {
      margin-top: 16px;
    }
  }
`;

interface SectionCardProps {
  padding?: string;
  flex?: number;
}

export const SectionCard = styled.div<SectionCardProps>`
  display: flex;
  flex: ${(props) => (props.flex ? props.flex : "initial")};
  flex-wrap: wrap;
  background-color: ${colors.WHITE};
  border: 1px solid ${colors.GREY_LIGHT};
  border-radius: 4px;
  padding: ${(props) => (props.padding ? props.padding : "24px")};
  max-width: 100%;

  &:first-child {
    margin-right: 16px;
  }

  @media screen and (max-width: 767px) {
    flex: 1;
    justify-content: center;
    margin-right: 0 !important;
  }

  @media screen and (max-width: 320px) {
    &:not(:last-child) {
      margin: 0 0 16px !important;
    }
  }

  @media screen and (min-width: 321px) {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  @media screen and (min-width: 768px) {
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

export const UploadLogoWrapper = styled.div<{ disabled: boolean }>`
  width: 160px;
  height: 200px;
  margin: 0 40px 0 0;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "initial")};

  @media screen and (max-width: 425px) {
    margin: 0 0 16px;
  }

  @media screen and (min-width: 426px) and (max-width: 768px) {
    margin: 0 32px 0 0;
  }

  .upload-zone {
    margin: 0 !important;
    height: 100%;
    border-radius: 6px;
  }

  .photo-add-button {
    padding: 0 !important;
  }

  .description {
    color: ${colors.BLUE};
    font-weight: 600;
  }

  .image-wrapper img {
    padding: 0;
    max-width: 160px;
    max-height: 200px;
  }
`;

interface RowProps {
  marginBottom?: string;
}

export const Row = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "initial")};
  height: 64px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    height: auto;
  }
`;

interface ColumnProps {
  flex?: number;
  margin?: string;
  height?: string;
}

export const Column = styled.div<ColumnProps>`
  display: flex;
  flex: ${(props) => (props.flex ? props.flex : "initial")};
  flex-wrap: wrap;
  flex-direction: column;
  margin: ${(props) => (props.margin ? props.margin : "initial")};
  height: ${(props) => (props.height ? props.height : "initial")};
`;

interface InputWrapperProps {
  flex?: number;
  width?: string;
  minWidth?: number;
  maxWidth?: number;
  margin?: string;
  marginBottom?: string;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  display: flex;
  width: ${(props) => (props.width ? props.width : "30%")};
  min-width: ${(props) => (props.minWidth ? `${props.minWidth}px` : "inherit")};
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : "inherit")};
  margin: ${(props) => (props.margin ? props.margin : "initial")};

  &:not(:last-child) {
    margin-right: 32px;
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 8px;
    width: 100%;
  }

  .ant-switch-handle {
    top: 3px;
    width: 28px;
    height: 28px;

    &::before {
      border-radius: 50%;
    }
  }

  .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 28px - 2px);
  }

  .ant-switch-checked {
    background-color: ${colors.GREEN};
  }
`;

export const InputNumberWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
